<script setup lang="ts">
import { ElMessage } from 'element-plus'
import type { OptionType } from 'element-plus/es/components/select-v2/src/select.types.mjs'
import { ref, watch } from 'vue'
import type { IEquipmentTypeFilters } from '@/types/hvl/filters'
import { getEquipmentTypes } from '@/services/hvl/equipment-type'
import type { IEquipmentType } from '@/types/hvl/EquipmentType'

const props = withDefaults(defineProps<{ placeholder?: string }>(), {
  placeholder: 'Equipment Type',
})

const selectedEquipmentType = defineModel<IEquipmentType>()

const equipmentTypeFilterLoading = ref<boolean>(false)
const equipmentTypeFilterOptions = ref<OptionType[]>([])

const filterEquipmentTypes = async (query: string) => {
  try {
    equipmentTypeFilterLoading.value = true

    const filters: IEquipmentTypeFilters = {
      page: 1,
      per_page: 10,
      name: query == '' ? undefined : query,
    }

    const equipmentTypes = await getEquipmentTypes(filters)
    equipmentTypeFilterOptions.value = equipmentTypes.data.map((et: IEquipmentType) => {
      return {
        label: et.name,
        value: et,
      }
    })
  } catch {
    ElMessage.error('Failed to filter equipment types')
    equipmentTypeFilterOptions.value = []
  } finally {
    equipmentTypeFilterLoading.value = false
  }
}

// Add a watch to check selectedEquipmentType changes
watch(selectedEquipmentType, () => {
  if (selectedEquipmentType.value) {
    equipmentTypeFilterOptions.value.push({
      label: selectedEquipmentType.value.name,
      value: selectedEquipmentType.value,
    })
  }
})
</script>

<template>
  <el-select-v2
    v-model="selectedEquipmentType"
    :options="equipmentTypeFilterOptions"
    :loading="equipmentTypeFilterLoading"
    remote
    :remote-method="filterEquipmentTypes"
    filterable
    clearable
    value-key="id"
    :placeholder="props.placeholder"
    loading-text="Loading..."
  />
</template>
